import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.1_@biomejs+biome@1.9.4_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler_4fec32bc0d99de289ee444ae28af1a32/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/src/middleware/auth.global.ts";
import company_45data_45check_45global from "/opt/buildhome/repo/src/middleware/company-data-check.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.1_@biomejs+biome@1.9.4_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler_4fec32bc0d99de289ee444ae28af1a32/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  company_45data_45check_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "analysis-display-mode": () => import("/opt/buildhome/repo/src/middleware/analysis-display-mode.ts"),
  onboarding: () => import("/opt/buildhome/repo/src/middleware/onboarding.ts")
}